import { isDefined } from "@omni/utils/helper.utils";
import {
    createContext,
    KeyboardEvent,
    MouseEvent,
    ReactNode,
    use
} from "react";

type ResultsPanelContextValue = {
    showResults: boolean;
    onMouseDown: (event: MouseEvent) => void;
    onKeyDown: (event: KeyboardEvent) => void;
};

type ResultsPanelContextProviderProps = {
    showResults: boolean;
    onMouseDown: (event: MouseEvent) => void;
    onKeyDown: (event: KeyboardEvent) => void;
    children: ReactNode;
};

export const ResultsPanelContext = createContext<
    ResultsPanelContextValue | undefined
>(undefined);

export const ResultsPanelContextProvider = ({
    showResults,
    onMouseDown,
    onKeyDown,
    children
}: ResultsPanelContextProviderProps) => {
    return (
        <ResultsPanelContext
            value={{
                showResults: showResults,
                onMouseDown: onMouseDown,
                onKeyDown: onKeyDown
            }}
        >
            {children}
        </ResultsPanelContext>
    );
};

export const useResultsPanelContext = () => {
    const context = use<ResultsPanelContextValue | undefined>(
        ResultsPanelContext
    );

    if (!isDefined(context)) {
        throw new Error(`${ResultsPanelContext.displayName} is undefined.`);
    }

    return context;
};
